<!-- Un solo contenedor scrolleable para todos los grupos: si cada grupo
     tuviera el suyo, una tanda con muchos errores dejaría los chips de
     timbrados encerrados en un scroll aparte. -->
<div class="detalle">
  @for (grupo of grupos(); track grupo.severidad) {
    <section
      class="grupo"
      [class.grupo--error]="grupo.severidad === 'error'"
      [class.grupo--exito]="grupo.severidad === 'exito'"
      [class.grupo--proceso]="grupo.severidad === 'proceso'"
    >
      <header class="grupo__head">
        <h4 class="grupo__titulo">
          {{ grupo.titulo
          }}<span class="grupo__conteo">
            @if (grupo.parcial) {
              {{ grupo.items.length }} de {{ grupo.totalTanda }}
            } @else {
              {{ grupo.items.length }}
            }
          </span>
        </h4>

        @if (!grupo.detallado) {
          <button
            type="button"
            class="copiar"
            [class.copiar--hecho]="copiado() === 'copia:' + grupo.severidad"
            [attr.aria-label]="'Copiar las referencias de ' + grupo.titulo"
            [title]="
              copiado() === 'copia:' + grupo.severidad
                ? 'Referencias copiadas'
                : 'Copiar referencias'
            "
            (click)="copiarReferencias(grupo)"
          >
            <span
              nz-icon
              [nzType]="copiado() === 'copia:' + grupo.severidad ? 'check' : 'copy'"
              nzTheme="outline"
            ></span>
          </button>
        }
      </header>

      @if (!grupo.items.length) {
        <p class="grupo__sin-carga">
          No vienen en los {{ registros().length }} renglones cargados de la bitácora.
        </p>
      } @else if (grupo.detallado) {
        <div class="registros" role="list">
          @for (registro of grupo.items; track registro.id ?? $index) {
            <div class="registro" role="listitem">
              <span class="registro__ref">{{ referenciaCorta(registro) }}</span>

              <div class="registro__cuerpo">
                <intelishs-status-text class="registro__estatus" [tone]="meta(registro).tono">
                  {{ estatusTexto(registro) }}
                </intelishs-status-text>
                @if (registro.mensaje) {
                  <p class="registro__mensaje">{{ registro.mensaje }}</p>
                }
              </div>

              @if (registro.idx) {
                <button
                  type="button"
                  class="copiar"
                  [class.copiar--hecho]="copiado() === registro.idx"
                  [attr.aria-label]="'Copiar folio de ' + referenciaCorta(registro)"
                  [title]="copiado() === registro.idx ? 'Folio copiado' : 'Copiar folio'"
                  (click)="copiarFolio(registro)"
                >
                  <span
                    nz-icon
                    [nzType]="copiado() === registro.idx ? 'check' : 'copy'"
                    nzTheme="outline"
                  ></span>
                </button>
              }
            </div>
          }
        </div>
      } @else {
        <!-- Referencias colapsadas a tramos: una carga de 600 renglones cabe
             en una línea y sigue contestando "¿mi fila N pasó?". -->
        <p class="resumen">
          <span class="resumen__prefijo">{{ grupo.resumen.prefijo }}</span
          >{{ tokensVisibles(grupo).join(', ') }}
          @if (grupo.parcial) {
            <span class="resumen__parcial" title="Solo los renglones cargados">…</span>
          }
        </p>

        @if (tokensOcultos(grupo); as ocultos) {
          <button type="button" class="resumen__mas" (click)="alternarResumen(grupo)">
            y {{ ocultos }} tramos más
          </button>
        } @else if (grupo.resumen.tokens.length > 12) {
          <button type="button" class="resumen__mas" (click)="alternarResumen(grupo)">
            Ver menos
          </button>
        }
      }
    </section>
  }
</div>

<p class="sr-only" role="status" aria-live="polite">{{ avisoCopia() }}</p>

@if (hayRegistrosOcultos()) {
  <p class="tanda__nota">
    Mostrando {{ registros().length }} de {{ total() }} renglones. Los conteos del resumen sí cubren
    la tanda completa.
  </p>
}
